import React, {Component} from 'react'
import DataTable from 'react-data-table-component';
import Select from "react-select";
import {customStyles, FilterContainer, SearchButton, SearchContainer, SearchInput, SelectContainer} from "./index";
import request from "../../utils/request";
import {observer} from "mobx-react";
import {action, observable} from "mobx";
import {LoadingIcon} from "../Patients/List";
import {LinkText} from "../Landing";


@observer
export class AllPatients extends Component {
  @observable loading = true
  @observable allPatients = []

  state = {
    searchQuery: '',
    siteFilter: {value: 'all', label: 'All Sites'},
    medFilter: {value: 'all', label: 'All Meds'},
    statusFilter: {value: 'all', label: 'All Statuses'},
    adherenceFilter: {value: 'monthlyAdherence', label: 'Monthly Adherence'},
  };

  getColumns = () => [
    {
      name: 'Patient',
      selector: row => `${row.name} (${row.patientUID})`,
      cell: row => (
        <LinkText href={`/adherence-stats/${row._id}`}>
          {row.name} ({row.patientUID})
        </LinkText>
      ),
      sortable: true,
    },
    {
      name: 'Monitor ID',
      selector: row => row.monitorID,
      sortable: true,
    },
    {
      name: 'Battery Level',
      selector: row => row.batteryLevel,
      cell: (row) => (
        <div
          style={{
            backgroundColor: row.batteryLevel === 'High' ? 'green' :
              row.batteryLevel === 'Med'? 'Yellow': 'Red',
            color: row.batteryLevel === 'Med'? 'black': 'white',
            padding: '5px',
            borderRadius: '4px',
            textAlign: 'center',
            width: '80px'
          }}
        >
          {row.batteryLevel}
        </div>
      ),
      sortable: false,
    },
    // {
    //   name: 'Status',
    //   selector: row => row.status,
    //   cell: (row) => (
    //     <div
    //       style={{
    //         backgroundColor: row.status === 'Active' ? 'green' : 'red',
    //         color: 'white',
    //         padding: '5px',
    //         borderRadius: '4px',
    //         textAlign: 'center',
    //       }}
    //     >
    //       {row.status}
    //     </div>
    //   ),
    // },
    {
      name: 'Prescription',
      selector: row => row.prescription,
    },
    {
      name: this.state.adherenceFilter.label,
      selector: row => row[this.state.adherenceFilter.value],
      sortable: true,
      cell: row => (
        <span>
          {(row[this.state.adherenceFilter.value] || 0).toFixed(1)}%
        </span>
      ),
    },
    {
      name: 'Last 5 Doses',
      selector: row => row.lastFiveDoses,
      cell: row => (
        <div style={{display: 'flex', justifyContent: 'space-around', minWidth: '100px'}}>
          {(row.lastFiveDoses || []).map((dose, index) => (
            <span key={index} className={`fas ${dose ? 'fa-check' : 'fa-times'}`}
                  style={{color: dose ? 'green' : 'red'}}>
          </span>
          ))}
        </div>
      ),
      sortable: false,
    },
  ];

  handleSearchChange = (e) => {
    this.setState({searchQuery: e.target.value});
  };

  handleSelectChange = (selectedOption, action) => {
    this.setState({[action.name]: selectedOption});
  };

  @action
  setAllPatients = allPatients => {
    this.allPatients = allPatients
    this.loading = false
  }
  fetchAllPatients = async () => {
    const res = await request('/api/adherenceDashboard/getAllPatients')
    if (res.success) {
      this.setAllPatients(res.data.allPatients)
    }
  }

  componentDidMount() {
    this.fetchAllPatients().then();
  }

  render() {
    if (this.loading) {
      return <LoadingIcon className="fas fa-sync fa-spin"/>
    }

    const {
      searchQuery,
      siteFilter, medFilter,
      statusFilter, adherenceFilter
    } = this.state;

    const siteOptions = [
      {value: 'all', label: 'All Sites'},
      {value: 'site1', label: 'Site 1'},
      {value: 'site2', label: 'Site 2'},
    ];

    const medOptions = [
      {value: 'all', label: 'All Meds'},
      {value: 'med1', label: 'Med 1'},
      {value: 'med2', label: 'Med 2'},
    ];

    const statusOptions = [
      {value: 'all', label: 'All Statuses'},
      {value: 'active', label: 'Active'},
      {value: 'inactive', label: 'Inactive'},
    ];

    const adherenceOptions = [
      {value: 'monthlyAdherence', label: 'Monthly Adherence'},
      {value: 'weeklyAdherence', label: 'Weekly Adherence'},
    ];

    return (
      <React.Fragment>
        <FilterContainer>
          <SearchContainer>
            <SearchInput
              type="text"
              placeholder="Search Patient"
              value={searchQuery}
              onChange={this.handleSearchChange}
            />
            <SearchButton><span className="fas fa-search"/></SearchButton>
          </SearchContainer>
          <SelectContainer>
            <Select
              name="siteFilter"
              value={siteFilter}
              onChange={this.handleSelectChange}
              options={siteOptions}
              placeholder="All Sites"
            />
          </SelectContainer>
          <SelectContainer>
            <Select
              name="medFilter"
              value={medFilter}
              onChange={this.handleSelectChange}
              options={medOptions}
              placeholder="All Meds"
            />
          </SelectContainer>
          <SelectContainer>
            <Select
              name="statusFilter"
              value={statusFilter}
              onChange={this.handleSelectChange}
              options={statusOptions}
              placeholder="All Statuses"
            />
          </SelectContainer>
          <SelectContainer>
            <Select
              name="adherenceFilter"
              value={adherenceFilter}
              onChange={this.handleSelectChange}
              options={adherenceOptions}
              placeholder="Adherence"
            />
          </SelectContainer>
        </FilterContainer>

        <DataTable
          noHeader
          columns={this.getColumns()}
          data={this.allPatients}
          customStyles={customStyles}
          pagination
        />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/AdherenceDashboard/AllPatients.jsx